var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConcretingRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.6277,
    cy: 50.3194,
    r: 50,
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8994 25.3194C37.0994 25.3194 25.9244 36.5194 25.9244 50.3194C25.9244 64.1194 37.0994 75.3194 50.8994 75.3194C64.7244 75.3194 75.9244 64.1194 75.9244 50.3194C75.9244 36.5194 64.7244 25.3194 50.8994 25.3194ZM50.9244 70.3194C39.8744 70.3194 30.9244 61.3694 30.9244 50.3194C30.9244 39.2694 39.8744 30.3194 50.9244 30.3194C61.9744 30.3194 70.9244 39.2694 70.9244 50.3194C70.9244 61.3694 61.9744 70.3194 50.9244 70.3194Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1744 37.8194H48.4244V52.8194L61.5494 60.6944L63.4244 57.6194L52.1744 50.9444V37.8194Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcretingRequest);
export default __webpack_public_path__ + "static/media/concreting-request.aca621a7b09669b7da502a9dd5d25ff6.svg";
export { ForwardRef as ReactComponent };